export default __webpack_public_path__ + "static/dudu-feature7-fd8fb4d206466bab40ecb151bb6d9b48.png";